export default {
  REGULAR_FONT: 'WorkSans-Regular',
  MEDIUM_FONT: 'WorkSans-Medium',
  BC_FONT: 'BasierCircle',
  BC_REGULAR_FONT: 'BasierCircle-Regular',
  BC_MEDIUM_FONT: 'BasierCircle-Medium',
  BC_BOLD_FONT: 'BasierCircle-Bold',
  BC_SEMI_BOLD_FONT: 'BasierCircle-SemiBold',
};
